module.exports = __webpack_public_path__ + "static/img/map1.aed7022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map1.jpg
// module id = iac6
// module chunks = 1